const stylesStatus = [
  {
    label: 'Aceptada',
    backgroundStyle: 'green',
    idStatus: true
  },
  {
    label: 'Rechazada',
    backgroundStyle: 'red',
    idStatus: false
  },
  {
    label: 'Pendiente',
    backgroundStyle: 'gray',
    idStatus: null
  }
];

export default stylesStatus;
